import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  xpBarFill,
  xpBarLabel
} from "@/modals/constructor/hero/HeroModal/helpers"
import { IHeroLevel } from "@/store/apis/heroAPI/hero.types"
import styles from "./XpBar.module.scss"

export const XpBar: FC<{ level: IHeroLevel }> = ({ level }) => {
  const { t } = useTranslation("hero")

  return (
    <div className={styles.XpBar}>
      <div
        className={styles.XpBar_fill}
        style={{ width: `${xpBarFill(level) * 100}%` }}
      />
      <span className={styles.XpBar_text}>
        {xpBarLabel(level) ?? t("level.max")}
      </span>
    </div>
  )
}
